import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
function Admission() {
  useEffect(() => {
    document.title = "Documents Required-  CARMEL CONVENT SCHOOL, DHARUHERA";
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>Admission</li>
                <li>Documents Required</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Documents Required</h2>
            </div>
          </div>
          <div className="row">
            {/* <div className="col-lg-12"> 
                 <h5>Documents Required for admissions:</h5> 
                    <p>While coming to submit the registration form the following documents to be submitted without fail.</p>
                       <ul className="mainlist">
                        <li> Birth certificate of your child with name written on it. ( Copy and original ) </li>
                        <li> Adhaar card with name written on it.  ( Copy and original ) </li>
                        <li> Parents adhaar card. (Copy self attested by both the parents ) </li>
                        <li> Family ID </li>
                        <li> 5*3 size photograph child with parents. </li>
                        <li> 3 passport size photographs of the child. </li>
                        <li> Presence of both the parents compulsory while filling the admission form as the signature of both the parents required. </li>
                        <li> Transfer certificate and report card of your ward from the school where they are coming. ( By the 20th of April) after that only admission confirmed. </li>
                    </ul> 
              </div> */}
            <div className="col-lg-12">
              <h5>Documents Required for New Admission</h5>

              <h6>Nursery</h6>
              <ul className="mainlist">
                <li>3 passport-size photographs of the child.</li>
                <li>
                  5" × 3" size family photograph (child with both parents).
                </li>
                <li>Photocopy of the Birth Certificate.</li>
                <li>Aadhaar Card photocopy of the child.</li>
                <li>Aadhaar Card photocopies of both parents.</li>
              </ul>

              <h6>Classes L.KG - VI</h6>
              <ul className="mainlist">
                <li>3 passport-size photographs of the child.</li>
                <li>
                  5" × 3" size family photograph (child with both parents).
                </li>
                <li>Aadhaar Card photocopy of the child.</li>
                <li>Aadhaar Card photocopies of both parents.</li>
                <li>Original Transfer Certificate (TC).</li>
                <li>Photocopy of the previous class Report Card.</li>
              </ul>

              <h5 className="mt-4">Instructions</h5>
              <ul className="mainlist">
                <li>
                  Fill in the admission form carefully and neatly, ensuring that
                  the child’s name and parents’ names are entered exactly as
                  they appear on the Birth Certificate and Transfer Certificate
                  (TC).
                </li>
                <li>
                  Presence of both parents is compulsory at the time of
                  admission, as signatures of both parents are required on the
                  admission form.
                </li>
                <li>
                  Please bring all original documents along with their
                  photocopies while submitting the admission form.
                </li>
                <li>
                  School Fee is payable quarterly in advance in April, July,
                  October, and January.
                </li>
                <li>
                  The last date for fee deposit is the 10th of each quarter
                  month. A late fee of Rs. 100/- per month will be charged
                  thereafter.
                </li>
                <li>
                  Admission charges and all other charges are non-refundable.
                </li>
                <li>
                  If the cheque is dishonoured by the bank for any reason, an
                  additional charge of Rs. 500/- will be charged.
                </li>
              </ul>
            </div>
            <div className="col-lg-12 mt-4">
              <h5>Age Eligibility Criteria</h5>
              <p>Your child is eligible if born between:</p>

              <div className="table-responsive maintable">
                <table className="table">
                  <thead>
                    <tr>
                      <th>Class</th>
                      <th>Date of Birth Range</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Nursery</td>
                      <td>1st April 2022 - 31st March 2023</td>
                    </tr>
                    <tr>
                      <td>L.KG</td>
                      <td>1st April 2021 - 31st March 2022</td>
                    </tr>
                    <tr>
                      <td>U.KG</td>
                      <td>1st April 2020 - 31st March 2021</td>
                    </tr>
                    <tr>
                      <td>Grade I</td>
                      <td>1st April 2019 - 31st March 2020</td>
                    </tr>
                    <tr>
                      <td>Grade II</td>
                      <td>1st April 2018 - 31st March 2019</td>
                    </tr>
                    <tr>
                      <td>Grade III</td>
                      <td>1st April 2017 - 31st March 2018</td>
                    </tr>
                    <tr>
                      <td>Grade IV</td>
                      <td>1st April 2016 - 31st March 2017</td>
                    </tr>
                    <tr>
                      <td>Grade V</td>
                      <td>1st April 2015 - 31st March 2016</td>
                    </tr>
                    <tr>
                      <td>Grade VI</td>
                      <td>1st April 2014 - 31st March 2015</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Admission;
